import React, { useEffect, useRef } from "react";

const SCRIPT = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";

/**
 * Cloudflare Turnstile, the bot check on the signup form. Rendered only when
 * the server says it is configured (a site key); `onToken` receives the
 * token to send along, or null when it expires.
 */
const TurnstileWidget = ({ siteKey, onToken }) => {
  const box = useRef(null);

  useEffect(() => {
    if (!siteKey) return undefined;

    let widgetId = null;
    let cancelled = false;

    const draw = () => {
      if (cancelled || !window.turnstile || !box.current) return;
      widgetId = window.turnstile.render(box.current, {
        sitekey: siteKey,
        callback: (token) => onToken(token),
        "expired-callback": () => onToken(null),
        "error-callback": () => onToken(null),
      });
    };

    if (window.turnstile) {
      draw();
    } else {
      let script = document.querySelector(`script[src="${SCRIPT}"]`);
      if (!script) {
        script = document.createElement("script");
        script.src = SCRIPT;
        script.async = true;
        document.head.appendChild(script);
      }
      script.addEventListener("load", draw);
    }

    return () => {
      cancelled = true;
      if (widgetId !== null && window.turnstile) window.turnstile.remove(widgetId);
    };
  }, [siteKey, onToken]);

  return siteKey ? <div ref={box} className="flex justify-center" /> : null;
};

export default TurnstileWidget;
